export const assert200 = (response) => {
  if (response.status !== 200) {
    throw new Error('Unexpected status code: ' + response.status);
  }
  return response;
};

/**
 * fetch then `assert200` then `response.json()`.
 */
export const fetchJson = (url, init) =>
  fetch(url, init).then(assert200).then(response => response.json());



// WEBPACK FOOTER //
// ./src/utils/fetch_utils.js